import { ESSENTIAL_CARE_ACTIVATION_ROOT_PATH } from './Activation/paths';

// ReactRouter Redirects using `from` prop only works for `Switch` children.
// See https://reacttraining.com/react-router/web/api/Redirect/from-string
// Intended to be rendered inside AppRoutes.
export const REDIRECT_PATHS = [
  {
    // `ec/activate` is the URL provided on Essential Care kit packaging. EC is short for "Essential Care".
    fromPaths: ['/ec/activate'],
    to: ESSENTIAL_CARE_ACTIVATION_ROOT_PATH,
  },
];
